import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import './Header.css';

const Header = () => {
  const [user, setUser] = useState(null);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  const handleLogin = async () => {
    const email = prompt('Introduce tu email:');
    const password = prompt('Introduce tu contraseña:');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert('Inicio de sesión exitoso');
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      alert('Error al iniciar sesión');
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      alert('Cierre de sesión exitoso');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      alert('Error al cerrar sesión');
    }
  };

  return (
    <header className="header">
      <nav className="nav">
        <ul className="nav-list">
          <li className="nav-item">
            <Link to="/" className="nav-link">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/blog" className="nav-link">Blog</Link>
          </li>
          {user && (
            <li className="nav-item">
              <Link to="/new-post" className="nav-link">Crear Nuevo Artículo</Link>
            </li>
          )}
        </ul>
        <div className="auth-buttons">
          {user ? (
            <button onClick={handleLogout} className="auth-button">Cerrar Sesión</button>
          ) : (
            <button onClick={handleLogin} className="auth-button">Iniciar Sesión</button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;